import { useNavigate } from "react-router-dom";
import { LTE_CLOSED_STATUSES } from "../api/lte";
import { useLteTasks } from "../hooks/useLte";
import { useMyTasks } from "../hooks/useMyTasks";
import { useProjects } from "../hooks/usePm";
import { Icons } from "./Icons";

/** Cartes Accueil (design « accueil unifié ») : raccourcis Terrain / Mes tâches /
 * Projets avec compteurs. La carte Temps est la badge-stage au-dessus. */
export function HomeDashboardCards() {
  const navigate = useNavigate();
  const lte = useLteTasks();
  const myTasks = useMyTasks();
  const projects = useProjects();

  const terrainOpen = (lte.data?.items ?? []).filter(
    (t) => !LTE_CLOSED_STATUSES.includes(t.status),
  ).length;
  const activeProjects = (projects.data?.items ?? []).filter(
    (p) => p.status === "active",
  ).length;

  const cards = [
    {
      id: "terrain",
      label: "Terrain",
      icon: Icons.tools,
      count: terrainOpen,
      unit: "tâche(s) ouverte(s)",
      path: "/terrain",
    },
    {
      id: "taches",
      label: "Mes tâches",
      icon: Icons.list,
      count: myTasks.items.length,
      unit: "en cours",
      path: "/taches",
    },
    {
      id: "projets",
      label: "Projets",
      icon: Icons.briefcase,
      count: activeProjects,
      unit: "actif(s)",
      path: "/projets",
    },
  ];

  return (
    <div className="home-cards">
      {cards.map((c) => (
        <button
          key={c.id}
          className="home-card"
          onClick={() => navigate(c.path)}
        >
          <span className="ic">
            <c.icon size={18} sw={1.8} />
          </span>
          <span className="count">{c.count}</span>
          <span className="lbl">{c.label}</span>
          <span className="unit">{c.unit}</span>
        </button>
      ))}
    </div>
  );
}
